import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function Pricing() {
  return <section className="py-14 px-6 max-w-6xl mx-auto" id="pricing" data-id="element-199">
      <div className="text-center mb-8" data-id="element-200">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-201">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>
        <CountdownTimer data-id="element-202" />
        <p className="text-naranja font-bold text-lg mt-4 bg-naranja/10 inline-block px-6 py-2 rounded-full border border-naranja/20" data-id="element-203">
          ⚠️ Después sube $10.000 ARS. No vuelve.
        </p>
      </div>

      <h3 className="text-center text-2xl font-bold text-white mb-6" data-id="element-204">
        ELEGÍ TU MEGAPACK
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch" data-id="element-205">
        {/* Card A */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-petroleo rounded-3xl p-8 border border-petroleoLight flex flex-col hover:-translate-y-1 transition-transform duration-300" data-id="element-206">
          <div className="text-4xl mb-4" data-id="element-207">📘</div>
          <h4 className="text-2xl font-bold text-white mb-2" data-id="element-208">
            MEGAPACK DOCENTE
          </h4>
          <p className="text-tealBrand font-medium mb-8" data-id="element-209">6 Tomos + 6 Bonos</p>

          <div className="mt-auto" data-id="element-210">
            <div className="mb-6" data-id="element-211">
              <div className="text-base text-gray-400 line-through font-medium mb-1" data-id="element-212">
                $89.000 ARS
              </div>
              <div className="flex items-baseline gap-2" data-id="element-213">
                <span className="text-4xl font-extrabold text-white tracking-tight" data-id="element-214">
                  $19.990
                </span>
                <span className="text-base text-gray-300 font-medium" data-id="element-215">ARS</span>
              </div>
            </div>
            <a id="cta-megapack" href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNC3E2Ac5Ul1LShxH6jwS2M/es-ar?_r=AQABdYqjLg5UUZFA4jNsRAT5afNnhJQ5SjWUn7cGz-dSVq0&cart_link_id=LqRVGwQM&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="w-full text-center bg-amarillo hover:bg-amarilloHover text-noche font-bold text-lg py-4 rounded-xl transition-colors shadow-lg" data-id="element-216">
              ⚡ QUIERO MI MEGAPACK 📚
            </a>
          </div>
        </motion.div>

        {/* Card B - Featured */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-petroleo rounded-3xl p-8 border-2 border-tealBrand relative flex flex-col shadow-[0_0_40px_rgba(20,184,166,0.15)] hover:-translate-y-1 transition-transform duration-300" data-id="element-217">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-tealBrand text-noche font-bold px-4 py-1 rounded-full text-sm tracking-wide" data-id="element-218">
            MÁS POPULAR
          </div>
          <div className="text-4xl mb-4" data-id="element-219">🏆</div>
          <h4 className="text-2xl font-bold text-white mb-2" data-id="element-220">
            MEGAPACK + CEREBRO DIGITAL ⭐
          </h4>
          <p className="text-tealBrand font-medium mb-4" data-id="element-221">
            6 Tomos + 6 Bonos + Sistema de Organización 360°
          </p>
          <p className="text-sm text-gray-300 mb-8" data-id="element-222">
            Notion + Drive + WhatsApp + Automatización de notas
          </p>

          <div className="mt-auto" data-id="element-223">
            <div className="mb-6" data-id="element-224">
              <div className="text-base text-gray-400 line-through font-medium mb-1" data-id="element-225">
                $119.000 ARS
              </div>
              <div className="flex items-baseline gap-2" data-id="element-226">
                <span className="text-4xl font-extrabold text-white tracking-tight" data-id="element-227">
                  $27.990
                </span>
                <span className="text-base text-gray-300 font-medium" data-id="element-228">ARS</span>
              </div>
            </div>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNC3ERKGkBLlKbBXeZgwHS6/es-ar?_r=AQABI4oUCQjYhRQVhqYGOzk2F25hFI0BRCcSYn5rxUsVdQc&cart_link_id=RKWwAu7G&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="w-full text-center bg-amarillo hover:bg-amarilloHover text-noche font-bold text-lg py-4 rounded-xl transition-colors shadow-lg" data-id="element-229">
              ⚡ QUIERO EL MEGAPACK + CEREBRO DIGITAL 📚
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}